import axios from 'axios';

/** localStorage keys — keep in sync with AuthService */
const TOKEN_KEY = '4inbedstays_token';
const USER_KEY = '4inbedstays_user';

/**
 * Paths (relative to baseURL) that must not send a stale JWT — e.g. login with bad cookies/token
 * would otherwise attach `Authorization` and confuse flows.
 */
const PUBLIC_AUTH_PATHS = [
	'/auth/login',
	'/auth/register',
	'/auth/forgot-password',
	'/auth/reset-password',
	'/auth/verify-email'
];

function isPublicAuthRequest(config) {
	const path = config?.url || '';
	return PUBLIC_AUTH_PATHS.some((p) => path.includes(p));
}

/**
 * Shared Axios instance for all frontend API calls.
 * Uses {@link REACT_APP_API_BASE_URL} (e.g. http://localhost:4000/api/v1).
 */
const api = axios.create({
	baseURL:
		process.env.REACT_APP_API_BASE_URL ||
		process.env.REACT_APP_API_URL ||
		'http://localhost:4000/api/v1',
	headers: {
		'Content-Type': 'application/json',
	},
});

api.interceptors.request.use(
	(config) => {
		if (!isPublicAuthRequest(config)) {
			const token = localStorage.getItem(TOKEN_KEY);
			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			}
		}
		return config;
	},
	(error) => Promise.reject(error)
);

api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			// Wrong password / unknown user returns 401 on POST /auth/login — do not clear session or hard-redirect
			if (isPublicAuthRequest(error.config)) {
				return Promise.reject(error);
			}
			localStorage.removeItem(TOKEN_KEY);
			localStorage.removeItem(USER_KEY);
			window.location.href = '/login';
		}
		return Promise.reject(error);
	}
);

export default api;
export { TOKEN_KEY, USER_KEY };
